<template lang="pug">
  form(@submit.prevent="submit")
    fieldset(:disabled="loading")
      modal(active title="Verificação de conta bancária" @close="$router.back()" :overlay-closable="false")
        .body(slot="modal-body")
          .columns
            .column.col-12.my-2.py-2(v-if="error")
              .toast.toast-error
                a.btn.btn-clear.float-right(@click="error = null")
                | {{ error.message }}
            .column.col-12
              cite Após validar sua conta, você poderá receber pelo seu link e conteúdos
            .column.col-12.divider.text-center(data-content="Dados pessoais")
            .column.col-6.col-md-12
              form-group(label="Tipo de pessoa" :validation="$v.form" field="person_type")
                person-type-select.form-select(v-model="$v.form.person_type.$model")
            .column.col-6.col-md-12
              form-group(label="CNPJ" :validation="$v.form" field="cnpj" v-if="form.person_type === 'Pessoa Jurídica'")
                the-mask.form-input(mask="##.###.###/####-##" v-model="$v.form.cnpj.$model")
              form-group(label="CPF" :validation="$v.form" field="cpf" v-else)
                the-mask.form-input(mask="###.###.###-##" v-model="$v.form.cpf.$model")
            .column.col-8.col-sm-12
              form-group(label="Nome da empresa" :validation="$v.form" field="company_name" v-if="form.person_type === 'Pessoa Jurídica'")
                input.form-input(v-model="$v.form.company_name.$model")
              form-group(label="Nome" :validation="$v.form" field="name" v-else)
                input.form-input(v-model="$v.form.name.$model")
            .column.col-4.col-sm-12
              form-group(label="Telefone" :validation="$v.form" field="telephone")
                the-mask.form-input(:mask="['(##) #####-####', '(##) ####-####']" v-model="$v.form.telephone.$model")
            .column.col-12.divider.text-center(data-content="Dados de endereço")
            .column.col-5.col-md-12
              form-group(label="Cep" :validation="$v.form" field="cep")
                cep-input.form-input(v-model="$v.form.cep.$model" @found-address="onFoundAddress" autocomplete="chrome-off")
            .column.col-7.col-md-12
              form-group(label="Cidade" :validation="$v.form" field="city")
                input.form-input(v-model="$v.form.city.$model")
            .column.col-9.col-md-12
              form-group(label="Endereço" :validation="$v.form" field="address")
                input.form-input(v-model="$v.form.address.$model")
            .column.col-3.col-md-12
              form-group(label="Estado" :validation="$v.form" field="state")
                the-mask.form-input(mask="AA" v-model="$v.form.state.$model")
            .column.col-12.divider.text-center(data-content="Dados bancários")
            .column.col-8.col-md-12(v-if="form.person_type === 'Pessoa Jurídica'")
              form-group(label="Nome do responsável" :validation="$v.form" field="resp_name")
                input.form-input(v-model="$v.form.resp_name.$model")
            .column.col-4.col-md-12(v-if="form.person_type === 'Pessoa Jurídica'")
              form-group(label="CPF do responsável" :validation="$v.form" field="resp_cpf")
                the-mask.form-input(mask="###.###.###-##" v-model="$v.form.resp_cpf.$model")
            .column.col-12.col-6
              form-group(label="Banco" :validation="$v.form" field="bank")
                bank-select(v-model="$v.form.bank.$model" input-class="form-input")
            .column.col-6.col-md-12
              form-group(label="Tipo da conta" :validation="$v.form" field="account_type")
                account-type-select.form-select(v-model="$v.form.account_type.$model")
            .column.col-6.col-md-12
              form-group(label="Agência" :validation="$v.form" field="bank_ag")
                input.form-input(v-model="$v.form.bank_ag.$model")
            .column.col-6.col-md-12
              form-group(label="Número da conta" :validation="$v.form" field="bank_cc")
                input.form-input(v-model="$v.form.bank_cc.$model")
        div(slot="modal-footer")
          button.btn.btn-primary(:disabled="$v.form.$invalid" :class="{ loading }")
            i.fas.fa-check
            |  Solicitar verificação

</template>

<script>
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import AccountTypeSelect from './components/AccountTypeSelect'
import BankSelect from './components/BankSelect'
import PersonTypeSelect from './components/PersonTypeSelect'
import iuguSubAccounts from '@/services/api/iuguSubAccounts'
import { cpf, cnpj } from '@/lib/validators'

export default {
  components: { AccountTypeSelect, BankSelect, PersonTypeSelect },
  data() {
    return {
      loading: false,
      error: null,
      form: {
        person_type: '',
        cnpj: '',
        cpf: '',
        company_name: '',
        name: '',
        cep: '',
        address: '',
        city: '',
        state: '',
        telephone: '',
        resp_name: '',
        resp_cpf: '',
        bank: '',
        account_type: '',
        bank_ag: '',
        bank_cc: '',
      },
    }
  },
  props: { fetchInfo: { type: Function, required: true } },
  validations: {
    form: {
      person_type: { required },
      cnpj: {
        required: requiredIf(
          nested => nested.person_type === 'Pessoa Jurídica',
        ),
        cnpj,
      },
      cpf: {
        required: requiredIf(nested => nested.person_type === 'Pessoa Física'),
        cpf,
      },
      company_name: {
        required: requiredIf(
          nested => nested.person_type === 'Pessoa Jurídica',
        ),
      },
      name: {
        required: requiredIf(nested => nested.person_type === 'Pessoa Física'),
      },
      address: { required },
      cep: { required, minLength: minLength(8) },
      city: { required },
      state: { required },
      telephone: { required },
      resp_name: {
        required: requiredIf(
          nested => nested.person_type === 'Pessoa Jurídica',
        ),
      },
      resp_cpf: {
        required: requiredIf(
          nested => nested.person_type === 'Pessoa Jurídica',
        ),
        cpf,
      },
      bank: { required },
      bank_ag: { required },
      account_type: { required },
      bank_cc: { required },
    },
  },
  methods: {
    onFoundAddress({ address, city, district, state }) {
      if (address && district) this.form.address = `${address}, ${district}`
      this.form.city = city
      this.form.state = state
    },

    async submit() {
      try {
        this.error = null
        this.loading = true
        const { data } = await iuguSubAccounts.verification(this.form)
        this.fetchInfo()
        this.$router.back()
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.body
  overflow-x hidden
</style>
